import React from "react";
import styled from "styled-components";
import { useDropzone } from "react-dropzone";

import { default as useApiHook } from "../api/UseAxios";

import { showToast } from "../utils";
import { FileUploadIcon } from "../svgExport";

// Supported file types mapping
const mimeMap: any = {
  pdf: "application/pdf",
  doc: "application/doc",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  csv: "text/csv",
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  mp4: "video/mp4",
};

export interface FileProps {
  fileResources: any;
  setFileResources: any;
  subText: string;
  acceptedFiles: string[];
}

const makeFormData = (files: any[], resourceType: string) => {
  const formData = new FormData();

  for (let i = 0; i < files.length; i++) {
    formData.append("files", files[i]); // Use "files" instead of "files[]"
  }
  formData.append("resource_type", resourceType);
  return formData;
};

function FileUpload({ fileResources, setFileResources, subText, acceptedFiles }: FileProps) {
  // const dispatch = useDispatch();

  let resource_type = "defect";

  const { fetchData: uploadFile, loading: uploadLoading } = useApiHook<{
    data: any;
  }>({
    endpoint: `s3/upload-files_by_pass/`,
    method: "POST",
  });

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: Object.fromEntries(acceptedFiles.map((file: string) => [mimeMap[file], [`.${file}`]])),
    onDrop: (acceptedFiles) => {
      if (uploadLoading) return;
      if (acceptedFiles?.length) {
        const updatedList = [
          ...fileResources,
          ...acceptedFiles.map((file) =>
            Object.assign(file, {
              preview: URL.createObjectURL(file),
            })
          ),
        ];
        const newUpdatedList = updatedList?.filter((item) => item !== undefined);
        handleFileUpload(newUpdatedList);
      }
    },
  });

  const handleFileUpload = async (files: any) => {
    const filteredFiles = files?.filter((file: any) => file.preview !== undefined);
    const response = (await uploadFile({
      payload: makeFormData(filteredFiles, resource_type),
    })) as {
      code: number | null;
      error?: string | null | undefined;
      data?: any[];
    };

    if (response?.error) {
      return showToast("Error", response.error);
    }

    const updatedList = response?.data?.map((file) => {
      // const match = files?.find(
      //   (item: any) => item?.name?.replaceAll(/\s+/g, '') === file?.file_name // regex to remove space
      // );
      const match = files?.find((item: any) => item?.name?.split(".")[0].replaceAll(/\s+/g, "") === file?.file_name?.split(".")[0].replaceAll(/\s+/g, ""));
      if (match) {
        return { ...file, download: match?.preview };
      }
      return file;
    });

    const finalList = [...files?.filter((x: any) => x.preview === undefined), ...updatedList!];

    // dispatch(setResources(finalList));

    setFileResources(finalList);
  };

  return (
    <FileUploadContainer>
      <div>
        <Section {...getRootProps()} $isDragActive={isDragActive} className="fileUploadSection">
          <div className="dragDropContainer">
            <input {...getInputProps()} />
            <Container>
              <FileUploadIcon />
              <TextContainer>
                <Text1>Drag & drop it here or Choose a file </Text1>
                <Text2>{subText}</Text2>
              </TextContainer>
            </Container>

            <UploadButtonContainer>
              <UploadButton>{uploadLoading ? "Uploading..." : "Upload File"}</UploadButton>
            </UploadButtonContainer>
          </div>
        </Section>
      </div>
    </FileUploadContainer>
  );
}
const FileUploadContainer = styled.div`
  display: flex;
  padding: 15px 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin: 15px;
  align-self: stretch;
  border-radius: 10px;
  border: 1px dashed #cbd0dc;
  background: var(--Grey-09, #f9fafb);
`;
const Text2 = styled.span`
  color: #6a7378;
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const Text1 = styled.span`
  color: #090b0e;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const UploadButton = styled.span`
  color: #164781;
  text-align: center;
  font-family: "Lato", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;
`;

const UploadButtonContainer = styled.div`
  display: flex;
  padding: 6px 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 30px;
  border: 1px solid #8ba9d7;
  cursor: pointer;
  cursor: pointer;
`;

const Section = styled.section<{ $isDragActive: boolean }>`
  .dragDropContainer {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
`;

const Container = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: column;
  align-items: center;
`;
export const Sections = styled.div`
  .detailSection {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    align-items: center;
    margin-top: 8px;

    .fileName {
      display: flex;
      width: 316px;
      height: 30px;
      padding: 4px 10px;
      justify-content: space-between;
      // align-items: center;
      border-radius: 4px;
      border: 1px solid #26bf94;
      background: #fff;

      p {
        color: #6a7378;
        text-align: center;
        font-family: Mulish;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 150% */
      }

      svg {
        border-radius: 100px;
        background: rgba(230, 83, 60, 0.2);
      }
    }
  }
`;
export default FileUpload;
